<template>
<div v-if="redirectToThirdParty" class="text-center">
    <h4 class="my-5">You will be redirected to your card's issuer's verification page to authorize this payment in {{ countDownSeconds + (countDownSeconds>1? ' Seconds' : ' Second') }}.</h4>
    <a href="javascript:void(0)" class="change-option" @click.prevent="$emit('cancelRedirect')"> Cancel </a>
</div>
<div v-else>
    <h5 class="mt-2 text-center">Select a Card to Pay</h5>

    <div class="form-group mb-2" :key="key" v-for="(card,key) in cards" @click.prevent="$emit('callOnePipe', card.uid)">
        <div class="saved" @mouseover="hoverEffect(true, key)" @mouseleave="hoverEffect(false, key)" :style="{'borderColor' : (hover && hoverKey == key) ? `${client_info.colors.app}` : '' }">

            <a href="#" title="Remove this card" @click.prevent.stop="$emit('handleAttemptCardRemoval', key)" class="close"></a>

            <div class="title mb-1 mt-2 text-left pl-2" @mouseover="hoverEffect(true, key)" @mouseleave="hoverEffect(false, key)" :style="{ 'width': '200px', 'color' : (hover && hoverKey == key) ? `${client_info.colors.app}` : '' }">
                {{ formatCard(card.number.toUpperCase()) }}
            </div>
            <i v-if="['visa', 'mastercard', 'verve'].includes(card.scheme.toLowerCase())" :class="card.scheme.toLowerCase()"></i>
        </div>
    </div>

    <div class="text-center my-3 mt-4">
        <div id="new-saved" class="switch">
            <a @click.prevent="triggerCardInput" class="left active pointer" @mouseover="cardRemovalHoverEffect(true, 0)" @mouseleave="cardRemovalHoverEffect(false, 0)" :style="{ 'font-weight': 'bold', 'background' : (cardRemovalActionHover && cardRemovalActionHoverKey ==0) ? `#ffffff` : `${client_info.colors.app}`, 'color' : `#000 !important`, 'borderColor' : `${client_info.colors.app}`,}">USE A NEW CARD</a>
        </div>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from '../includes/bus.js'; // Masterpass, verve, visa

export default {
    props: {
        
        redirectToThirdParty: {
            type: Boolean,
            required: true,
            default: false,
        },
        client_info: {
            type: Object,
            required: true
        },

        cards: {
            type: Array,
            required: true,
        },
    },


    data() {
        return {
            loading: true,
            hoverKey: 0,
            hoverValue: '',
            hover: false,
            cardRemovalActionHover: '',
            cardRemovalActionHoverKey: '',
        }
    },
    methods: {
        pickCardToDelete(val) {
            this.$emit('pickCardToDelete', val);
        },
        handleAttemptCardRemoval(val) {
            this.$emit('handleAttemptCardRemoval', val);
        },
        gotoCardListing() {
            this.$emit('gotoCardListing');
        },
        triggerCardInput() {
            this.$emit('triggerCardInput');
            console.log('trigger card input')
        },
        triggerManageCard() {
            this.$emit('triggerManageCard');
        },

        isLoading(val = false) {
            this.$emit('isLoading', val);
        },
        hoverEffect(value, key) {
            this.hover = value
            this.hoverKey = key
        },
        cardRemovalHoverEffect(value, key) {
            this.cardRemovalActionHover = value
            this.cardRemovalActionHoverKey = key
        },
        formatCard (str) {
            str = str.toUpperCase();
            let prefix = str.slice(0, 4),
                prefix2 = str.slice(4, 8),
                prefix3 = str.slice(8, 12),
                suffix = str.slice(10),
                main = `${prefix} ${prefix2} ${prefix3} ${suffix}`;
            return main;
        }
    },
}
</script>
